import Box from '@mui/material/Box';
import YouTube from 'react-youtube';
import {parseYouTubeId} from '../util/youtube';

interface Props {
  url: string;
}

/**
 * Responsive (16:9) YouTube player.
 * Hiding infos and related content does not work any more, see https://developers.google.com/youtube/player_parameters
 */
export default function YouTubeVideo({url}: Props) {
  const videoId = parseYouTubeId(url);
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: 0,
        paddingBottom: '56.25%',
        '& iframe': {position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'},
      }}
    >
      <YouTube
        videoId={videoId}
        opts={{playerVars: {rel: 0, iv_load_policy: 3, loop: 1, playlist: videoId}}}
      />
    </Box>
  );
}
